// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetailsSkeleton-orderDetailsSkeletonTitle-wXpjE {
    max-width: 194px;
    height: 30px;
    background: var(--skeleton-secondary-bg);
    margin-bottom: 18px;
    border-radius: var(--radius-5);
}

.OrderDetailsSkeleton-orderDetailsSkeletonCardList-lVC0Y {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 9px));
    gap: 18px;
    grid-gap: 18px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
}

.OrderDetailsSkeleton-orderDetailsSkeletonCard-HVMCx {
    height: 93px;
    border-radius: var(--radius-3);
    background: var(--skeleton-secondary-bg);
}

.OrderDetailsSkeleton-orderDetailsSkeletonDivider-DSulr {
    border-top: 1px solid var(--primary-border);
    margin: 18px 0;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU,
.OrderDetailsSkeleton-orderDetailsSkeletonPhotoTitle-QKpvW {
    height: 28px;
    border-radius: var(--radius-5);
    background: var(--skeleton-secondary-bg);
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU {
    margin-bottom: 6px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonPhotoTitle-QKpvW {
    max-width: 127px;
    margin-bottom: 12px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoDesc-Eov5t {
    height: 26px;
    border-radius: var(--radius-5);
    background: var(--skeleton-secondary-bg);
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem1-f40y7 .OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU {
    max-width: 159px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem2-lQyGb .OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU {
    max-width: 102px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem3-IWNG2 .OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU {
    max-width: 129px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem1-f40y7 .OrderDetailsSkeleton-orderDetailsSkeletonInfoDesc-Eov5t {
    max-width: 359px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem2-lQyGb .OrderDetailsSkeleton-orderDetailsSkeletonInfoDesc-Eov5t {
    max-width: 303px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonInfoItem3-IWNG2 .OrderDetailsSkeleton-orderDetailsSkeletonInfoDesc-Eov5t {
    max-width: 192px;
}

.OrderDetailsSkeleton-orderDetailsSkeletonPhotoBox-ao4BM {
    max-width: 116px;
    height: 116px;
    border-radius: var(--radius-1);
    background: var(--skeleton-secondary-bg);
}

@media (max-width: 1199px) {
    .OrderDetailsSkeleton-orderDetailsSkeletonCardList-lVC0Y {
        grid-template-columns: 100%;
        -webkit-box-align: initial;
            -ms-flex-align: initial;
                align-items: initial;
        -webkit-box-pack: initial;
            -ms-flex-pack: initial;
                justify-content: initial;
    }
}

@media (max-width: 767px) {
    .OrderDetailsSkeleton-orderDetailsSkeletonTitle-wXpjE {
        height: 28px;
    }

    .OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU {
        height: 26px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/OrderDetailsSkeleton/OrderDetailsSkeleton.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,iDAAwD;IACxD,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;QACpB,yBAAwB;YAAxB,sBAAwB;gBAAxB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".orderDetailsSkeletonTitle {\n    max-width: 194px;\n    height: 30px;\n    background: var(--skeleton-secondary-bg);\n    margin-bottom: 18px;\n    border-radius: var(--radius-5);\n}\n\n.orderDetailsSkeletonCardList {\n    display: grid;\n    grid-template-columns: repeat(2, calc((100% / 2) - 9px));\n    gap: 18px;\n    grid-gap: 18px;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.orderDetailsSkeletonCard {\n    height: 93px;\n    border-radius: var(--radius-3);\n    background: var(--skeleton-secondary-bg);\n}\n\n.orderDetailsSkeletonDivider {\n    border-top: 1px solid var(--primary-border);\n    margin: 18px 0;\n}\n\n.orderDetailsSkeletonInfoTitle,\n.orderDetailsSkeletonPhotoTitle {\n    height: 28px;\n    border-radius: var(--radius-5);\n    background: var(--skeleton-secondary-bg);\n}\n\n.orderDetailsSkeletonInfoTitle {\n    margin-bottom: 6px;\n}\n\n.orderDetailsSkeletonPhotoTitle {\n    max-width: 127px;\n    margin-bottom: 12px;\n}\n\n.orderDetailsSkeletonInfoDesc {\n    height: 26px;\n    border-radius: var(--radius-5);\n    background: var(--skeleton-secondary-bg);\n}\n\n.orderDetailsSkeletonInfoItem1 .orderDetailsSkeletonInfoTitle {\n    max-width: 159px;\n}\n\n.orderDetailsSkeletonInfoItem2 .orderDetailsSkeletonInfoTitle {\n    max-width: 102px;\n}\n\n.orderDetailsSkeletonInfoItem3 .orderDetailsSkeletonInfoTitle {\n    max-width: 129px;\n}\n\n.orderDetailsSkeletonInfoItem1 .orderDetailsSkeletonInfoDesc {\n    max-width: 359px;\n}\n\n.orderDetailsSkeletonInfoItem2 .orderDetailsSkeletonInfoDesc {\n    max-width: 303px;\n}\n\n.orderDetailsSkeletonInfoItem3 .orderDetailsSkeletonInfoDesc {\n    max-width: 192px;\n}\n\n.orderDetailsSkeletonPhotoBox {\n    max-width: 116px;\n    height: 116px;\n    border-radius: var(--radius-1);\n    background: var(--skeleton-secondary-bg);\n}\n\n@media (max-width: 1199px) {\n    .orderDetailsSkeletonCardList {\n        grid-template-columns: 100%;\n        align-items: initial;\n        justify-content: initial;\n    }\n}\n\n@media (max-width: 767px) {\n    .orderDetailsSkeletonTitle {\n        height: 28px;\n    }\n\n    .orderDetailsSkeletonInfoTitle {\n        height: 26px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderDetailsSkeletonTitle": `OrderDetailsSkeleton-orderDetailsSkeletonTitle-wXpjE`,
	"orderDetailsSkeletonCardList": `OrderDetailsSkeleton-orderDetailsSkeletonCardList-lVC0Y`,
	"orderDetailsSkeletonCard": `OrderDetailsSkeleton-orderDetailsSkeletonCard-HVMCx`,
	"orderDetailsSkeletonDivider": `OrderDetailsSkeleton-orderDetailsSkeletonDivider-DSulr`,
	"orderDetailsSkeletonInfoTitle": `OrderDetailsSkeleton-orderDetailsSkeletonInfoTitle-cM7HU`,
	"orderDetailsSkeletonPhotoTitle": `OrderDetailsSkeleton-orderDetailsSkeletonPhotoTitle-QKpvW`,
	"orderDetailsSkeletonInfoDesc": `OrderDetailsSkeleton-orderDetailsSkeletonInfoDesc-Eov5t`,
	"orderDetailsSkeletonInfoItem1": `OrderDetailsSkeleton-orderDetailsSkeletonInfoItem1-f40y7`,
	"orderDetailsSkeletonInfoItem2": `OrderDetailsSkeleton-orderDetailsSkeletonInfoItem2-lQyGb`,
	"orderDetailsSkeletonInfoItem3": `OrderDetailsSkeleton-orderDetailsSkeletonInfoItem3-IWNG2`,
	"orderDetailsSkeletonPhotoBox": `OrderDetailsSkeleton-orderDetailsSkeletonPhotoBox-ao4BM`
};
module.exports = ___CSS_LOADER_EXPORT___;
